import { useRef } from 'react';
import EmptyState from './EmptyState';
import ErrorState from './ErrorState';
import Skeleton from './Skeleton';
import { FALLBACK_COL, useDroppedColumns, useFitWidth } from './fitColumns';

// §2.6 Table: t-dense, sticky header — a Grid without editing, for Admin / Reports / PTO.
// columns: [{ key, label, width?, align?, render?(row) }]. state: 'data' | 'loading' | 'error'.
// density 'portal' (§3.3, HD-9): the Portal profile's low density, t-body at 15/22 and 16 px row padding.
// fit (HD-10, ui/fitColumns.js): 'auto' (default) drops columns from the right at <= 1024 px until the rest fit; true always;
// false never. A column without a width counts as FALLBACK_COL px.
export default function Table({ columns: all, rows, rowKey = r => r.id, caption, state = 'data', empty, error, maxHeight, density, fit = 'auto' }) {
  const wrap = useRef(null);
  const avail = useFitWidth(wrap, fit);
  const dropped = useDroppedColumns(all, all.map(c => (typeof c.width === 'number' ? c.width : FALLBACK_COL)), avail);
  const columns = dropped.size ? all.filter((_, i) => !dropped.has(i)) : all;
  if (state === 'error') return <ErrorState {...error} />;
  return (
    <div className="ui ui-table-wrap" ref={wrap} style={maxHeight ? { maxHeight } : undefined}>
      <table className={density === 'portal' ? 'ui-table ui-table--portal' : 'ui-table'}>
        {caption && <caption className="ui-sr">{caption}</caption>}
        <colgroup>{columns.map(c => <col key={c.key} style={c.width ? { width: c.width } : undefined} />)}</colgroup>
        <thead><tr>{columns.map(c => <th key={c.key} scope="col" data-align={c.align}>{c.label}</th>)}</tr></thead>
        <tbody>
          {state === 'loading' && Array.from({ length: 5 }, (_, i) => (
            <tr key={i}>{columns.map(c => <td key={c.key}><Skeleton width="70%" /></td>)}</tr>
          ))}
          {state === 'data' && rows.map(r => (
            <tr key={rowKey(r)} data-key={rowKey(r)}>{columns.map((c, i) => <td key={c.key} data-align={c.align} className={i === 0 ? 'ui-table__first' : undefined}>{c.render ? c.render(r) : r[c.key]}</td>)}</tr>
          ))}
        </tbody>
      </table>
      {state === 'data' && rows.length === 0 && empty && <EmptyState {...empty} />}
    </div>
  );
}
